import React from 'react';
import { useNavigate } from 'react-router-dom';
import wordmarkWhite from '../assets/site/logos/tarana-wordmark-white.png';

export function Footer() {
  const navigate = useNavigate();
  const go = (path: string) => () => navigate(path);

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <img src={wordmarkWhite} alt="Tarana" onClick={go('/')} />
          <p>The professional home for the music industry.</p>
        </div>
        <div>
          <div className="fcol-title">Product</div>
          <div className="fcol-links">
            <span className="fcol-link" onClick={go('/for-artists')}>For Artists</span>
            <span className="fcol-link" onClick={go('/for-organizations')}>For Organizations</span>
            <span className="fcol-link" onClick={go('/for-listeners')}>For Listeners</span>
          </div>
        </div>
        <div>
          <div className="fcol-title">Company</div>
          <div className="fcol-links">
            <span className="fcol-link" onClick={go('/about')}>About</span>
            <span className="fcol-link" onClick={go('/about')}>Contact</span>
          </div>
        </div>
        <div>
          <div className="fcol-title">Legal</div>
          <div className="fcol-links">
            <span className="fcol-link" onClick={go('/terms-of-use')}>Terms of Use</span>
            <span className="fcol-link" onClick={go('/privacy-policy')}>Privacy Policy</span>
            <span className="fcol-link" onClick={go('/content-policy')}>Content Policy</span>
            <span className="fcol-link" onClick={go('/community-guidelines')}>Community Guidelines</span>
          </div>
        </div>
        <div>
          <div className="fcol-title">Get the app</div>
          <div className="fcol-links">
            <a className="fcol-link" href="https://apps.apple.com/in/app/tarana-music/id6740995739" target="_blank" rel="noopener noreferrer">App Store</a>
            <a className="fcol-link" href="https://play.google.com/store/apps/details?id=com.tarana.taranaMusicApp&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">Google Play</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-legal">
          Tarana Media Private Limited · Hyderabad, India · CIN U72900TG2021PTC151126<br />
          © 2026 Tarana Media Private Limited. All rights reserved.
        </div>
        <div className="footer-legal" style={{ textAlign: 'right' }}>
          hey@taranamusic.in
        </div>
      </div>
    </footer>
  );
}
